module.exports = __webpack_public_path__ + "img/symbol_9.74112d7a.png";